module.exports = __webpack_public_path__ + "img/t5-banner.ee2da3a4.png";